type Obj = Record<string | symbol | number, unknown>;

export function isObjsShallowEqual(obj1: Obj, obj2: Obj) {
  const obj1Keys = Object.keys(obj1);

  if (obj1Keys.length !== Object.keys(obj2).length) return false;

  for (const key of obj1Keys) {
    if (obj2[key] !== obj1[key]) return false;
  }

  return true;
}
